module.exports = {
	"maxCardsCount": -1,
	"maxCouponCount": 24,
	"cssClassPrefix": "couponplatz-",
	"cardsUrl": "https://api.couponplatz.de/api/couponplatz/content",
	"storageKey": "couponplatz-cart",
	"print": {
		"actionUrl": "http://codestylers.de/cp/pdf.php",
		"openInNewTab": true,
		"cartInputName": "cart",
		"minNoOfCoupons": 4,
		"pdfFileName": "couponplatz.de_coupons.pdf",
		"forceDownload": false,
		"enabled": true
	},
	"epost": {
		"actionUrl": "https://api.couponplatz.de/api/couponplatz/epost",
		"idPrefix": "couponplatz-epost-",
		"enabled": true,
		"minNoOfCoupons": 4,
		"dataFields": [
			{
				"name": "firstname",
				"label": "Vorname",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 2,
				"maxLength": 30,
				"errorMsgMissing": "Verrate uns bitte Deinen Vornamen.",
				"errorMsgInvalid": ""
			},
			{
				"name": "lastname",
				"label": "Nachname",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 2,
				"maxLength": 30,
				"errorMsgMissing": "Für den Postversand brauchen wir Deinen Nachnamen.",
				"errorMsgInvalid": ""
			},
			{
				"name": "street",
				"label": "Straße",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 2,
				"maxLength": 30,
				"errorMsgMissing": "In welche Straße sollen die Coupons geliefert werden?",
				"errorMsgInvalid": ""
			},
			{
				"name": "streetnumber",
				"label": "Hausnummer",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 1,
				"maxLength": 10,
				"errorMsgMissing": "Bitte gib Deine Hausnummer an.",
				"errorMsgInvalid": ""
			},
			{
				"name": "zipcode",
				"label": "PLZ",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 5,
				"maxLength": 5,
				"errorMsgMissing": "Bitte gib Deine Postleitzahl an.",
				"errorMsgInvalid": ""
			},
			{
				"name": "city",
				"label": "Ort",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 2,
				"maxLength": 30,
				"errorMsgMissing": "In welche Stadt können wir die Coupons liefern?",
				"errorMsgInvalid": ""
			},
			{
				"name": "newsletter",
				"label": "newsletter_subscribe",
				"type": "checkbox",
				"required": false,
				"test": "",
				"minLength": 0,
				"maxLength": 0,
				"errorMsgMissing": "",
				"errorMsgInvalid": ""
			},
			{
				"name": "email",
				"label": "E-Mail-Adresse",
				"type": "text",
				"required": true,
				"test": "",
				"minLength": 5,
				"maxLength": 255,
				"errorMsgMissing": "Um Dir den Newsletter zusenden zu können, benötigen wir Deine E-Mail-Adresse.",
				"errorMsgInvalid": "Bitte gib eine gültige E-Mail-Adresse an."
			},
			{
				"name": "tos",
				"label": "JA, sendet mir jetzt auch die Coupon-News, damit ich nie wieder Rabatte verpasse!",
				"type": "checkbox",
				"required": false,
				"test": "",
				"minLength": 0,
				"maxLength": 0,
				"errorMsgMissing": "",
				"errorMsgInvalid": ""
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/couponplatz.config.json
// module id = 69
// module chunks = 0